import { format as formatDateFn } from 'date-fns';

export const convertTimeToSeconds = (time:string) => {
    if (!time) {
        return 0;
    }
    // Check if no hours and append 00 if not
    if (time && time.split(':').length === 2) {
        time = `00:${time}`;
    }
    const [hours, minutes, seconds] = time.split(':').map(parseFloat);
    return hours * 3600 + minutes * 60 + seconds;
};

export const formatTime = (seconds:number) => {
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds - (hours * 3600)) / 60);
    let secs = Math.floor(seconds % 60);

    let formattedTime = [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        secs.toString().padStart(2, '0'),
    ];

    // If the hours are 0, we remove them from the formatted time
    if (hours === 0) {
        formattedTime.shift();
    }

    return formattedTime.join(':');
}

export const formatSongTime = (seconds: number) => {
    // Calculate whole minutes
    const minutes = Math.floor(seconds / 60);

    // Calculate remaining seconds
    const remainingSeconds = Math.floor(seconds % 60);

    // Format the remaining seconds to always show two digits
    const formattedSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds;

    // Return the formatted time
    return `${minutes}:${formattedSeconds}`;
}


export const formatDate = (date: Date | string, formatString: string): string => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return formatDateFn(dateObj, formatString);
};

